import { useState } from "react"

import StepMember from "./StepMember"
import StepSubscription from "./StepSubscription"
import StepPayment from "./StepPayment"
import StepSuccess from "./StepSuccess"
import { fr } from "../../locales/fr"
import { SubscriptionStepper } from "../../components/subscriptions/SubscriptionStepper"

export default function NewSubscription() {
  const [step, setStep] = useState(1)

  const [member, setMember] = useState(null)
  const [subscription, setSubscription] = useState(null)
  const [payment, setPayment] = useState(null)

  const steps = fr.wizard.steps

  return (
    <div className="mx-auto max-w-6xl space-y-8">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-foreground">{fr.wizard.title}</h1>
        <p className="mt-2 max-w-2xl text-sm text-muted-foreground">{fr.wizard.subtitle}</p>
      </div>

      <div className="rounded-lg border border-border bg-card/50 p-4 sm:p-6">
        <SubscriptionStepper currentStep={step} labels={steps} />
      </div>

      {step === 1 && (
        <StepMember
          next={setStep}
          setMember={setMember}
        />
      )}

      {step === 2 && (
        <StepSubscription
          member={member}
          next={setStep}
          setSubscription={setSubscription}
        />
      )}

      {step === 3 && (
        <StepPayment
          member={member}
          subscription={subscription}
          next={setStep}
          setPayment={setPayment}
        />
      )}

      {step === 4 && (
        <StepSuccess member={member} payment={payment} />
      )}
    </div>
  )
}
